import { render } from "./MaterialsRouters.vue?vue&type=template&id=79e9fffa"
import script from "./MaterialsRouters.vue?vue&type=script&lang=js"
export * from "./MaterialsRouters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__